export enum NavigationFragments {
  Dependents = 'Dependents',
  MaritalStatus = 'MaritalStatus',
  ScrollToFirstError = 'ScrollToFirstError',
  Sponsor = 'Sponsor',
  //Groups = 'Groups',
}
